"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var TabBar_1 = require("../../atoms/_TabBar/TabBar");

var OnPageNavigation =
/** @class */
function (_super) {
  __extends(OnPageNavigation, _super);

  function OnPageNavigation() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.uuid = _this.props.id || uniqid_1["default"]("OnPageNavigation-");
    _this.state = {
      activeElementId: _this.props.initialOpenId || "",
      doesFit: !!_this.props.initialOpenId
    };

    _this.onScroll = function (activeElementIds) {
      var activeElementId = activeElementIds.length > 0 ? activeElementIds[0] : _this.props.initialOpenId;
      if (activeElementId !== _this.state.activeElementId) _this.setState({
        activeElementId: activeElementId
      });
    };

    _this.onItemsDontFit = function (itemsFit) {
      _this.setState({
        doesFit: itemsFit
      });
    };

    _this.changeHandler = function (activeElementIndex, event) {
      utils_1.WindowEvents.scrollIntoView(document.getElementById(_this.idTargets[activeElementIndex]));

      if (_this.idTargets[activeElementIndex] !== _this.state.activeElementId && _this.props.onChange) {
        _this.props.onChange(_this.idTargets[activeElementIndex], event);
      }
    };

    return _this;
  }

  OnPageNavigation.prototype.componentDidMount = function () {
    this.idTargets = this.props.navigationObject.map(function (item) {
      return item.idTarget;
    });
    utils_1.WindowEvents.addVisibilityCallback(this.onScroll, this.idTargets, utils_1.WindowEvents.Visibility.TOP_CLIPPED, this.containerRef.offsetHeight + 1 // +1 so that it doesn't hide when you click the first element
    );
    utils_1.WindowEvents.addStickyElement(this.uuid, this.containerRef);
  };

  OnPageNavigation.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeVisibilityCallback(this.onScroll);
    utils_1.WindowEvents.removeStickyElement(this.uuid);
  };

  OnPageNavigation.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        navigationObject = _a.navigationObject,
        logoArea = _a.logoArea,
        buttonArea = _a.buttonArea;
    var _b = this.state,
        doesFit = _b.doesFit,
        activeElementId = _b.activeElementId;
    return React.createElement("div", {
      id: this.uuid,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "onpagenavigation", className, !activeElementId && CSSPrefix_1.lsgPre + "onpagenavigation__hidden"]),
      ref: function ref(element) {
        _this.containerRef = element;
      },
      role: "navigation"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "onpagenavigation-logoarea"
    }, logoArea), React.createElement(TabBar_1.TabBar, {
      className: CSSPrefix_1.lsgPre + "onpagenavigation-tabbar",
      openIndex: this.idTargets && this.idTargets.indexOf(activeElementId),
      role: "navigation",
      onKeyDown: this.changeHandler,
      onItemsDontFit: this.onItemsDontFit,
      stacked: !doesFit
    }, navigationObject.map(function (_a, i) {
      var id = _a.id,
          _onClick = _a.onClick,
          _1 = _a.idTarget,
          item = __rest(_a, ["id", "onClick", "idTarget"]);

      return React.createElement(TabBar_1.TabBar.Item, __assign({}, item, {
        key: id,
        htmlAttrs: {
          onClick: function onClick(ev) {
            //HACK: add timeout for firefox to fix smooth scrolling
            setTimeout(function () {
              _this.changeHandler(i, ev);
            }, 0);
            return _onClick && _onClick(ev);
          }
        }
      }));
    })), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "onpagenavigation-buttonarea"
    }, buttonArea));
  };

  return OnPageNavigation;
}(React.Component);

exports.OnPageNavigation = OnPageNavigation;